module.exports = __webpack_public_path__ + "fonts/nationale-demibold.d46ad01.woff";